"use client";

import { useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

interface GlitchTextProps {
  children: string;
  className?: string;
  /** Play glitch once on mount, or on hover */
  trigger?: "mount" | "hover";
  as?: "span" | "p" | "h1" | "h2" | "h3";
}

export function GlitchText({
  children,
  className,
  trigger = "mount",
  as: Tag = "span",
}: GlitchTextProps) {
  const reduced = useReducedMotion();

  if (reduced) {
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <Tag
      className={cn(
        "glitch-text relative inline-block",
        trigger === "mount" && "glitch-text-mount",
        trigger === "hover" && "glitch-text-hover",
        className
      )}
      data-text={children}
    >
      {children}
    </Tag>
  );
}
